import React, { useState } from 'react';
import MainLayout from '../components/layout/MainLayout';
import Section from '../components/ui/Section';
import Button from '../components/ui/Button';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { handleStripeCheckout } from '../lib/stripe';

const Book = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [agreed, setAgreed] = useState(false);
  
  const ebookPriceId = import.meta.env.VITE_EBOOK_PRICE_ID;

  const takeaways = [
    "How to move from informal AI use to clear organisational oversight",
    "How to create safer AI boundaries for staff, volunteers, and teams",
    "How to protect trust, safeguarding, confidentiality, and data",
    "How to introduce practical AI governance without overwhelm",
    "How to keep human judgment at the centre of AI use",
    "How to develop a responsible and future-ready approach to AI adoption"
  ];

  const onBuyClick = async () => {
    if (!agreed) return;
    setIsLoading(true);
    
    try {
      await handleStripeCheckout(ebookPriceId);
    } catch (err) {
      alert(`Checkout Configuration Error: ${err.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <MainLayout>
      <Section bg="white" className="pt-20">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row gap-12 items-center">
          <div className="w-full md:w-1/2">
            <img 
              src="https://media-manager-c.questera.ai/greta-media/7c98abf852f963e06195176deed57bb9c81b4f53d205af5ca5b2f9af1b9cfaa840d35f6737e086b8644a3796bedcf0cc/images/aW1hZ2UvcG5n/0544aa9080d7a1bd34f91fb6b907bd13.png" 
              alt="Start AI Right for Nonprofits Book Cover" 
              className="rounded-lg shadow-2xl mx-auto max-w-sm w-full object-cover border border-gray-200" 
            />
          </div>
          <div className="w-full md:w-1/2">
            <h1 className="text-4xl font-bold text-brand-navy mb-6">Start AI Right for Nonprofits</h1>
            <p className="text-xl text-gray-700 mb-8 leading-relaxed">
              Practical guidance for mission-led leaders to build safer systems and establish clear organisational standards in the age of AI.
            </p>
            
            <h3 className="font-bold text-brand-navy text-lg mb-4 uppercase tracking-wider">What you will learn:</h3>
            <ul className="space-y-4 mb-10">
              {takeaways.map((item, i) => (
                <li key={i} className="flex items-start gap-3 text-gray-700">
                  <SafeIcon icon={FiIcons.FiCheckCircle} className="text-brand-teal w-6 h-6 shrink-0 mt-0.5" />
                  <span className="text-lg">{item}</span>
                </li>
              ))}
            </ul>

            {/* Mandatory Tick Box */}
            <div className="mb-6 p-5 bg-gray-50 rounded-2xl border border-gray-200">
              <label className="flex items-start gap-3 cursor-pointer group">
                <input 
                  type="checkbox" 
                  checked={agreed}
                  onChange={(e) => setAgreed(e.target.checked)}
                  className="mt-1 h-5 w-5 rounded border-gray-300 text-brand-teal focus:ring-brand-teal cursor-pointer"
                />
                <span className="text-sm text-gray-600 leading-relaxed select-none">
                  I confirm that supply of the digital content will begin immediately upon purchase and I acknowledge that I will lose my right to cancel once the download is available. I have read and agree to the <a href="https://www.aicolabstudio.com/terms" target="_blank" rel="noopener noreferrer" className="text-brand-teal font-bold hover:underline">Terms of Business</a>.
                </span>
              </label>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                variant="primary" 
                className={`text-lg min-w-[220px] ${!agreed ? 'opacity-50 grayscale cursor-not-allowed' : ''}`}
                onClick={onBuyClick}
                disabled={isLoading || !agreed}
              >
                {isLoading ? (
                  <>
                    <SafeIcon icon={FiIcons.FiLoader} className="animate-spin mr-2" />
                    Connecting...
                  </>
                ) : 'Buy E-Book (£9.99)'}
              </Button>
              <Button to="/resources/guide" variant="outline" className="text-lg">
                Download Free Guide
              </Button>
            </div>
            <p className="mt-4 text-xs text-gray-400 italic flex items-center gap-1">
              <SafeIcon icon={FiIcons.FiLock} className="w-3 h-3" />
              Payments secured by Stripe. Redirecting to secure checkout.
            </p>
          </div>
        </div>
      </Section>
    </MainLayout>
  );
};

export default Book;